// ============================================================
// PLATFORM DETECTION
// ============================================================
// Used to gate App Store / Play Store sensitive UI (billing,
// signup, paywalls) per Apple guideline 3.1.1 and equivalent
// on Google Play. Web (running in a browser) returns 'web' and
// behaves normally. iOS / Android (Capacitor wrapper) hide all
// billing & signup UI and direct users to the web.
// ============================================================

import { Capacitor } from '@capacitor/core';

// True when the app is running inside a native Capacitor shell (iOS or Android).
// We currently treat both the SAME — hide all billing / signup UI.
export const isMobileNative = Capacitor.getPlatform() !== 'web';

// Convenience: explicit platform booleans if we ever need to split iOS vs Android.
export const isIOS = Capacitor.getPlatform() === 'ios';
export const isAndroid = Capacitor.getPlatform() === 'android';
export const isWeb = Capacitor.getPlatform() === 'web';

// Default export for ergonomics.
const platform = { isMobileNative, isIOS, isAndroid, isWeb };
export default platform;
